import Toastr from "../../../itrust_common/components/Toastr"

const PARENT = 'MARKETING_BLAST_'

const DEFAULT_STATE = {
  templates: [],
  template: {},
  saving: false,
  loading: false,
  editing: false
}

let changes = null;
let templates = [];
export default function templatesReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {
    case `${PARENT}TEMPLATE_CREATE_PENDING`:
    case `${PARENT}TEMPLATES_LOAD_PENDING`:
    case `${PARENT}TEMPLATE_LOAD_PENDING`:
    case `${PARENT}TEMPLATE_UPDATE_PENDING`:
    case `${PARENT}TEMPLATE_DELETE_PENDING`:
    case `${PARENT}TEMPLATE_DUPLICATE_PENDING`:
      return { ...state, saving: true };

    case `${PARENT}TEMPLATE_CREATE_REJECTED`:
    case `${PARENT}TEMPLATES_LOAD_REJECTED`:
    case `${PARENT}TEMPLATE_LOAD_REJECTED`:
    case `${PARENT}TEMPLATE_UPDATE_REJECTED`:
    case `${PARENT}TEMPLATE_DELETE_REJECTED`:
    case `${PARENT}TEMPLATE_DUPLICATE_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = {
        saving: false,
        loading: false
      }
      return { ...state, ...changes };

    case `${PARENT}TEMPLATE_LOAD_FULFILLED`:
    case `${PARENT}TEMPLATES_LOAD_FULFILLED`:
      changes = {
        ...response,
        saving: false
      }
      return { ...state, ...changes };
    case `${PARENT}TEMPLATE_UPDATE_FULFILLED`:
    case `${PARENT}TEMPLATE_CREATE_FULFILLED`:
    case `${PARENT}TEMPLATE_DUPLICATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      changes = {
        ...response,
        saving: false
      }
      return { ...state, ...changes };

    case `${PARENT}TEMPLATE_DELETE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      templates = [...state.templates];
      for (const [index, template] of templates.entries()) {
        if (template.id === response.template.id) {
          templates.splice(index, 1);
        }
      }
      return { ...state, templates: templates };

    case `${PARENT}TEMPLATE_RESET`:
      changes = {
        template: {}
      }
      return { ...state, ...changes };

    case `${PARENT}TEMPLATE_EDIT`:
      changes = {
        editing: action.data,
      }
      return { ...state, ...changes };

    case `${PARENT}TEMPLATE_EDIT_CANCEL`:
      changes = {
        editing: false
      }
      return { ...state, ...changes };

    default:
      return state;
  }
}